.o{overflow:hidden;}